<template>
  <v-container fluid ma-0 pa-0>
    <div>
      <div class="d-flex justify-space-between align-center mb-8">
        <div class="d-flex p-4 rounded bg-white bordered w-fit tabs">
          <div
              class="nv_item d-flex pointer tab"
              @click="changeProvider('qportal')"
          >
            <SvgIcon
                text="QPortal"
                class="text-thin-gray"
                :class="{
                    'qp-tab-nav-is-active':venueForm.third_party === 'qportal',
                    'qp-tab-nav':venueForm.third_party !== 'qportal'
                  }"
            >
              <template v-slot:icon>
                <QportalIcon/>
              </template>
            </SvgIcon>
          </div>
          <div
              class="nv_item d-flex pointer tab"
              @click="changeProvider('priohub')"
          >
            <SvgIcon
                text="Priohub"
                class="text-thin-gray"
                :class="{
                    'qp-tab-nav-is-active':venueForm.third_party === 'priohub',
                    'qp-tab-nav':venueForm.third_party !== 'priohub'
                  }"
            >
              <template v-slot:icon>
                <PriohubIcon/>
              </template>
            </SvgIcon>
          </div>
        </div>
      </div>
    </div>

    <v-row align="center">
      <v-col cols="3">
        <h1 class="text-2xl">
          Venues
        </h1>
      </v-col>
      <v-col class="d-flex justify-center">
        <v-btn-toggle
            v-model="statusId"
            borderless
            class="q-tabs shadow-0 bordered"
            mandatory
            @change="getFilterData"
        >
          <v-btn height="40" value="all">All</v-btn>
          <v-btn height="40" value="1">Active</v-btn>
          <v-btn height="40" value="2">Inactive</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col class="d-flex align-center justify-end gap-x-4" lg="4" md="3">
        <v-col md="8">
          <v-text-field
              v-model="search"
              class="q-text-field shadow-0 bg-white"
              dense
              height="40"
              hide-details
              outlined
              placeholder="Search"
              @keyup="getFilterData"
          >
            <template #prepend-inner>
              <SearchIcon/>
            </template>
          </v-text-field>
        </v-col>
        <v-col md="4" v-if="venueForm.third_party !== 'qportal'">
          <v-btn

              class="white--text blue-color ml-1"
              color="darken-1"
              height="40"
              @click="addVenue"
          >
            <SvgIcon text="Add Venue">
              <template #icon>
                <AddIcon/>
              </template>
            </SvgIcon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>

    <v-row>
      <v-col
          v-for="(data) in venues"
          :key="data.id"
          lg="4"
          md="6"
          xl="3"
      >
        <VenueCard :venue="data" @editVenues="editVenues" @deleteVenue="deleteVenue"
                   @changeVenueStatus="changeVenueStatus" @changeFeaturedStatus="changeFeaturedStatus"/>
      </v-col>
    </v-row>


    <!--    new-->


    <!--    <v-row justify="center">-->
    <!--      <v-col-->
    <!--          align="center"-->
    <!--          cols="6"-->
    <!--          md="2"-->
    <!--          :class="providerQportal"-->
    <!--          style="cursor: pointer"-->
    <!--          @click="changeProvider('qportal')"-->
    <!--      >-->
    <!--        <v-icon color="#066a8c">mdi-post-outline</v-icon>-->
    <!--        <div class="mnuBtn">QPortal</div>-->
    <!--      </v-col>-->

    <!--      <v-col-->
    <!--          align="center"-->
    <!--          cols="6"-->
    <!--          md="2"-->
    <!--          :class="providerPriohub"-->
    <!--          @click="changeProvider('priohub')"-->
    <!--          style="cursor: pointer"-->
    <!--      >-->
    <!--        <v-icon color="#066a8c">mdi-view-dashboard</v-icon>-->
    <!--        <div class="mnuBtn">Priohub</div>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
<!--    <v-row class="ml-1">-->
<!--      <div class="md-card md-theme-default fullwidth">-->
<!--        <div class="md-card-content">-->
<!--          <div>-->
<!--            <div class="header_title">-->
<!--              <v-row no-gutters class="ma-3 header_title">-->
<!--                <v-col cols="12" md="2" class="pt-6">-->
<!--                  Venues-->
<!--                  <br/>-->
<!--                  <br/>-->
<!--                </v-col>-->

<!--                <v-col cols="12" md="10">-->
<!--                  <v-row>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-col cols="12" sm="3">-->
<!--                      <v-btn-->
<!--                          height="38"-->
<!--                          class="green-color"-->
<!--                          width="100%"-->
<!--                          dark-->
<!--                          @click="syncQportalVenues"-->
<!--                      >-->
<!--                        Sync with Qportal-->

<!--                        <v-icon right dark>mdi-sync</v-icon>-->
<!--                      </v-btn>-->
<!--                    </v-col>-->
<!--                    <v-col-->
<!--                        cols="12"-->
<!--                        md="2"-->
<!--                        sm="1"-->
<!--                        class="text-right"-->
<!--                        v-if="this.venueForm.third_party == 'priohub'"-->
<!--                    >-->
<!--                      <v-btn-->
<!--                          height="38"-->
<!--                          class="green-color"-->
<!--                          width="100%"-->
<!--                          dark-->
<!--                          @click="addVenue"-->
<!--                      >-->
<!--                        Add Venue-->
<!--                        <v-icon right dark>mdi-plus-circle</v-icon>-->
<!--                      </v-btn>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--            </div>-->
<!--            <div-->
<!--                class="md-content md-table md-theme-default table_borders"-->
<!--                table-header-color="orange"-->
<!--                value-->
<!--            >-->
<!--              <div-->
<!--                  class="md-content md-table-content md-scrollbar md-theme-default"-->
<!--              >-->
<!--                <table class="table border-collapse ">-->
<!--                  <thead class="">-->
<!--                  <tr class="opacity-70 tr-rounded tr-neon">-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">Venue Name</div>-->
<!--                        <div class="search_column">-->
<!--                          <v-autocomplete-->
<!--                              solo-->
<!--                              filled-->
<!--                              label="venue"-->
<!--                              v-model="searchParams.name"-->
<!--                              item-value="name"-->
<!--                              item-text="name"-->
<!--                              :loading="isLoading"-->
<!--                              :items="names"-->
<!--                              :search-input.sync="name"-->
<!--                              @change="getFilterData"-->
<!--                          ></v-autocomplete>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">Phone</div>-->
<!--                        <div class="search_column">-->
<!--                          <v-autocomplete-->
<!--                              solo-->
<!--                              filled-->
<!--                              label="phone"-->
<!--                              v-model="searchParams.phone"-->
<!--                              item-value="phone"-->
<!--                              item-text="phone"-->
<!--                              :loading="isLoading"-->
<!--                              :items="phones"-->
<!--                              :search-input.sync="phone"-->
<!--                              @change="getFilterData"-->
<!--                          ></v-autocomplete>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">Email</div>-->
<!--                        <div class="search_column">-->
<!--                          <v-autocomplete-->
<!--                              solo-->
<!--                              filled-->
<!--                              label="email"-->
<!--                              v-model="searchParams.email"-->
<!--                              item-value="email"-->
<!--                              item-text="email"-->
<!--                              :loading="isLoading"-->
<!--                              :items="emails"-->
<!--                              :search-input.sync="email"-->
<!--                              @change="getFilterData"-->
<!--                          ></v-autocomplete>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">-->
<!--                          Rate % Per Transaction-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">-->
<!--                          Fee Per Transaction-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">Make Featured</div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">Enable/Disable</div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                    <th class="md-table-head">-->
<!--                      <div-->
<!--                          class="md-table-head-container md-ripple md-disabled"-->
<!--                      >-->
<!--                        <div class="md-table-head-label">Actions</div>-->
<!--                      </div>-->
<!--                    </th>-->
<!--                  </tr>-->
<!--                  </thead>-->

<!--                  <tbody>-->
<!--                  <tr-->
<!--                      class="md-table-row"-->
<!--                      v-for="data in venues"-->
<!--                      :key="data.id"-->
<!--                  >-->
<!--                    <td class="md-table-cell">-->
<!--                      <div class="md-table-cell-container">-->
<!--                        {{ data.venue_name || "NA" }}-->
<!--                      </div>-->
<!--                    </td>-->
<!--                    <td class="md-table-cell">-->
<!--                      <div class="md-table-cell-container">-->
<!--                        {{ data.phone || "NA" }}-->
<!--                      </div>-->
<!--                    </td>-->
<!--                    <td class="md-table-cell">-->
<!--                      <div class="md-table-cell-container">-->
<!--                        {{ data.email || "NA" }}-->
<!--                      </div>-->
<!--                    </td>-->
<!--                    <td class="md-table-cell text-center">-->
<!--                      <div class="md-table-cell-container">-->
<!--                        {{ "AED " + data.commission_pct + " %" || "NA" }}-->
<!--                      </div>-->
<!--                    </td>-->
<!--                    <td class="md-table-cell text-center">-->
<!--                      <div class="md-table-cell-container">-->
<!--                        {{ "AED " + data.commission_extra || "NA" }}-->
<!--                      </div>-->
<!--                    </td>-->
<!--                    <td class="md-table-cell text-center">-->

<!--                      <v-tooltip top>-->
<!--                        <template v-slot:activator="{ on, attrs }">-->
<!--                          <v-btn-->
<!--                              v-bind="attrs"-->
<!--                              v-on="on"-->
<!--                              class="d-inline-block text-truncate"-->
<!--                              text-->
<!--                              @click="changeFeaturedStatus(data.id)"-->
<!--                          >-->
<!--                            <FeaturedIcon v-if="data.is_featured === 1"/>-->
<!--                            <FeatureIcon v-else/>-->
<!--                          </v-btn-->
<!--                          >-->
<!--                        </template>-->
<!--                        <span>{{-->
<!--                            data.is_featured == 1 ? "Remove from Featured" : "Feature"-->
<!--                          }}</span>-->
<!--                      </v-tooltip>-->
<!--                      &lt;!&ndash;                      <v-btn&ndash;&gt;-->
<!--                      &lt;!&ndash;                          v-if="data.is_featured == 1"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          small&ndash;&gt;-->
<!--                      &lt;!&ndash;                          color="success"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          class="d-inline-block text-truncate"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          dark&ndash;&gt;-->
<!--                      &lt;!&ndash;                          @click="changeFeaturedStatus(data.id)"&ndash;&gt;-->
<!--                      &lt;!&ndash;                      >&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <span class="text-truncate">Featured</span>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      </v-btn>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      <v-btn&ndash;&gt;-->
<!--                      &lt;!&ndash;                          v-else&ndash;&gt;-->
<!--                      &lt;!&ndash;                          small&ndash;&gt;-->
<!--                      &lt;!&ndash;                          color="primary"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          class="d-inline-block text-truncate"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          dark&ndash;&gt;-->
<!--                      &lt;!&ndash;                          @click="changeFeaturedStatus(data.id)"&ndash;&gt;-->
<!--                      &lt;!&ndash;                      >&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <span class="text-truncate">Make It Featured</span>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      </v-btn>&ndash;&gt;-->
<!--                    </td>-->
<!--                    <td class="md-table-cell text-center">-->
<!--                      <v-tooltip top>-->
<!--                        <template v-slot:activator="{ on, attrs }">-->
<!--                          <v-btn-->
<!--                              v-bind="attrs"-->
<!--                              v-on="on"-->
<!--                              :class="{'svg-stroke-green':data.status_id === 1,'svg-stroke-red':data.status_id === 2}"-->
<!--                              class="d-inline-block text-truncate"-->
<!--                              text-->
<!--                              @click="changeVenueStatus(data.id)"-->
<!--                          >-->
<!--                            <ActivateIcon v-if="data.status_id !== 2"/>-->
<!--                            <DeactivateIcon v-else/>-->
<!--                          </v-btn-->
<!--                          >-->
<!--                        </template>-->
<!--                        <span>{{-->
<!--                            data.status_id == 1 ? "Deactivate" : "Activate"-->
<!--                          }}</span>-->
<!--                      </v-tooltip>-->
<!--                    </td>-->
<!--                    <td class="md-table-cell text-center">-->

<!--                      <v-menu-->
<!--                          v-if="data.id"-->
<!--                          content-class="q-menu"-->
<!--                          offset-y-->
<!--                      >-->
<!--                        <template v-slot:activator="{ on, attrs }">-->
<!--                          <v-btn-->
<!--                              :ripple="false"-->
<!--                              class="text_capitalize"-->
<!--                              elevation="0"-->
<!--                              text-->
<!--                              v-bind="attrs"-->
<!--                              v-on="on"-->
<!--                          >-->
<!--                            <DotsIcon/>-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                        <v-list>-->
<!--                          <v-list-item class="my-1" @click="editVenues(data.id)">-->
<!--                            <SvgIcon text="Edit Venue"-->
<!--                                     class="font-medium text-sm gap-x-2">-->
<!--                              <template #icon>-->
<!--                                <ActivateIcon/>-->
<!--                              </template>-->
<!--                            </SvgIcon>-->
<!--                          </v-list-item>-->
<!--                          <v-divider/>-->
<!--                          <v-list-item class="my-1" @click="deleteVenue(data.id)">-->
<!--                            <SvgIcon text="Delete Venue" class="font-medium text-sm gap-x-2"-->
<!--                                     :class="{'red&#45;&#45;text svg-stroke-red':data.status_id === 1}"-->
<!--                            >-->
<!--                              <template #icon>-->
<!--                                <DeleteIcon/>-->
<!--                              </template>-->
<!--                            </SvgIcon>-->
<!--                          </v-list-item>-->
<!--                        </v-list>-->
<!--                      </v-menu>-->
<!--                      &lt;!&ndash;                        <v-btn&ndash;&gt;-->
<!--                      &lt;!&ndash;                          x-small&ndash;&gt;-->
<!--                      &lt;!&ndash;                          color="#00b0af"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          class="d-inline-block text-truncate"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          dark&ndash;&gt;-->
<!--                      &lt;!&ndash;                          fab&ndash;&gt;-->
<!--                      &lt;!&ndash;                          @click="editVenues(data.id)"&ndash;&gt;-->
<!--                      &lt;!&ndash;                        >&ndash;&gt;-->
<!--                      &lt;!&ndash;                          <v-icon dark>mdi-pencil</v-icon></v-btn&ndash;&gt;-->
<!--                      &lt;!&ndash;                        >&ndash;&gt;-->
<!--                      &lt;!&ndash;                        &nbsp;&nbsp;&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <v-btn&ndash;&gt;-->
<!--                      &lt;!&ndash;                          x-small&ndash;&gt;-->
<!--                      &lt;!&ndash;                          color="error"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          class="d-inline-block text-truncate"&ndash;&gt;-->
<!--                      &lt;!&ndash;                          dark&ndash;&gt;-->
<!--                      &lt;!&ndash;                          fab&ndash;&gt;-->
<!--                      &lt;!&ndash;                          @click="deleteVenue(data.id, index)"&ndash;&gt;-->
<!--                      &lt;!&ndash;                        >&ndash;&gt;-->
<!--                      &lt;!&ndash;                          <v-icon dark>{{ "mdi-delete" }}</v-icon></v-btn&ndash;&gt;-->
<!--                      &lt;!&ndash;                        >&ndash;&gt;-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  </tbody>-->
<!--                </table>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="w-full d-flex align-center justify-center">-->
<!--        <v-pagination-->
<!--            v-if="totalPages > 1"-->
<!--            v-model="page"-->
<!--            :length="totalPages"-->
<!--            :page="page"-->
<!--            class="new-pagination"-->
<!--            total-visible="7"-->
<!--        ></v-pagination>-->
<!--      </div>-->
<!--    </v-row>-->
    <v-dialog
        v-model="addVenueModel"
        persistent
        max-width="40%"
        scrollable
        v-resize="onResize"
    >
      <v-card ref="card">
        <v-card-title class="border-bottom"
        >
          <div class="w-full">
            <div class="d-flex justify-space-between align-center">
              <p class="mb-0 font-medium">
                {{ editFlag ? "Update" : "Add" }} Venue
              </p>
              <v-btn class="shadow-0" fab x-small @click="cancelForm">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

        </v-card-title
        >
        <v-card-text>
          <div class="p-y-4">
            <v-form v-on:submit.prevent ref="form" v-model="valid">
              <v-row>
                <div class="w-full d-flex align-center justify-center m-t-4 m-b-6">
                  <v-radio-group class="custom-radio-group"
                                 v-model="venueForm.third_party"
                                 row
                                 :rules="[(v) => !!v || 'Select third party']"
                                 hide-details="auto"
                  >
                    <v-radio
                             label="Qportal"
                             value="qportal"
                             color="red"
                             class="custom-radio"
                             @click="changeThirdParty()"

                    />
                    <v-radio
                             label="Priohub"
                             value="priohub"
                             color="red"
                             class="custom-radio"
                             selected
                             @click="changeThirdParty()"

                    />

                  </v-radio-group>
                </div>
                <v-col md="12">
                  <v-row>
                    <v-col md="5" lg="5" xl="4">
                      <div style="min-width: 200px;min-height: 200px">
                        <ImageUploader
                            :height="200"
                            :absolute_image_path="venueForm.image_path"
                            :image_path="venueForm.image_path"
                            default_image="default"
                            text="Venue Picture"
                            @upload="
                          (data) => {
                            venueForm.image = data;
                          }
                        "
                        ></ImageUploader>
                      </div>
                    </v-col>
                    <v-col md="7" lg="7" xl="8">
                      <v-row>
                        <v-col cols="6">
                          <label for="">Select Venue</label>
                          <v-select
                              v-model="changeVenue"
                              item-value="id"
                              item-text="name"
                              :items="thirdPartyVenues"
                              outlined
                              background-color="#fff"
                              return-object
                              dense
                              hide-details="auto"
                              class="q-autocomplete shadow-0"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <label for="">Venue Name</label>
                          <v-text-field
                              v-model="venueForm.name"
                              :rules="nameRules"
                              required
                              outlined
                              background-color="#fff"
                              dense
                              hide-details="auto"
                              class="q-text-field shadow-0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <label for="">Phone</label>
                          <v-text-field
                              v-model="venueForm.phone"
                              required
                              outlined
                              background-color="#fff"
                              dense
                              hide-details="auto"
                              class="q-text-field shadow-0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <label for="">Email</label>
                          <v-text-field
                              v-model="venueForm.email"
                              required
                              outlined
                              background-color="#fff"
                              dense
                              hide-details="auto"
                              class="q-text-field shadow-0"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <div class="w-full border-bottom">
                    <p style="color:#112A46; font-size: 14px; font-weight: 600; margin-bottom: 8px">Transaction and Venue Details</p>
                  </div>
                  <v-row class="m-y-2">
                    <v-col md="6">
                      <label for="">Rate % Per Transaction</label>
                      <v-text-field
                          outlined
                          dense
                          hide-details="auto"
                          class="q-text-field shadow-0"
                          :rules="commissionRules"
                          type="number"
                          background-color="#fff"
                          v-model="venueForm.commission_pct"
                          prefix="%"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <label for="">Fee Per Transaction</label>
                      <v-text-field
                          outlined
                          dense
                          hide-details="auto"
                          class="q-text-field shadow-0"
                          background-color="#fff"
                          type="number"
                          v-model="venueForm.commission_extra"
                          :rules="commissionRules"
                          prefix="AED"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="12" class="pt-0">
                      <label for="">Venue Description</label>
                      <v-textarea
                          name="description"
                          v-model="venueForm.description"
                          hide-details="auto"
                          dense
                          class="q-text-field shadow-0"
                          outlined
                          background-color="#fff"
                          rows="3"
                      ></v-textarea>
                    </v-col>

                  </v-row>


                  <div class="w-full border-bottom m-b-2">
                    <p style="color:#112A46; font-size: 14px; font-weight: 600; margin-bottom: 8px">Location</p>
                  </div>

                  <div class="relative p-t-4">
                    <v-btn
                        fab
                        absolute
                        x-small
                        elevation="1"
                        style="top:10px; right:0"
                        @click="mapFullScreenDialoge = true"
                    >
                      <v-icon>mdi-fullscreen</v-icon>
                    </v-btn>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-row no-gutters v-if="!mapFullScreenDialoge">
                            <v-col md="12">
                              <label for="">Select Address</label>
                              <v-autocomplete
                                  v-model="autocompleteLocationModel"
                                  :items="locationEntries"
                                  :search-input.sync="locationSearchText"
                                  item-text="value"
                                  dense
                                  hide-details="auto"
                                  class="shadow-0 q-autocomplete m-b-4"
                                  item-value="value"
                                  hide-no-data
                                  :loading="isLoading"
                                  :rules="[
                                      (v) => !!v || 'Location is required',
                                    ]"
                                  outlined
                                  background-color="#fff"
                                  @change="changeLocation"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <GmapMap
                              v-bind:center="{
                                  lat: parseFloat(venueForm.latitude),
                                  lng: parseFloat(venueForm.longitude),
                                }"
                              :zoom="12"
                              map-type-id="terrain"
                              @click="updateCoordinates"
                              style="width: 100%; height: 200px"
                          >
                            <GmapMarker
                                ref="mapRef"
                                :position="{
                                    lat: parseFloat(venueForm.latitude),
                                    lng: parseFloat(venueForm.longitude),
                                  }"
                                :clickable="true"
                                :draggable="true"
                                @dragend="updateCoordinates"
                            />
                          </GmapMap>
                        </v-col>
                        <v-col cols="6">
                          <label for="">Latitude</label>
                          <v-text-field
                              dense
                              class="q-text-field shadow-0"
                              hide-details="auto"
                              v-model="venueForm.latitude"
                              required
                              outlined
                              background-color="#fff"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <label for="">Longitude</label>
                          <v-text-field
                              dense
                              class="q-text-field shadow-0"
                              hide-details="auto"
                              v-model="venueForm.longitude"
                              required
                              outlined
                              background-color="#fff"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                  </div>


                  <div class="w-full border-bottom m-y-4">
                    <p style="color:#112A46; font-size: 14px; font-weight: 600; margin-bottom: 8px">Location</p>
                  </div>

                  <v-row class="mt-4" dense>
                    <v-col md="4" class="mt-0 pt-0">
                      <v-checkbox
                          class="qp-custom-checkbox no-height m-b-0"
                          v-model="venueForm.enable_duration"
                          label="Enable Duration"
                          :ripple="false"
                          hide-details="auto"
                      ></v-checkbox>
                    </v-col>
                    <v-col md="4" class="mt-0 pt-0">
                      <v-checkbox
                          class="qp-custom-checkbox no-height m-b-0"
                          v-model="venueForm.enable_attendee_limit"
                          label="Enable Attendee Limit"
                          :ripple="false"
                          hide-details="auto"
                      ></v-checkbox>
                    </v-col>
                    <v-col md="4"></v-col>
                    <v-col md="4" class="mt-0 pt-0">
                      <v-checkbox
                          class="qp-custom-checkbox no-height m-b-0"
                          v-model="venueForm.enable_ground_type"
                          label="Enable Ground Type"
                          :ripple="false"
                          hide-details="auto"
                      ></v-checkbox>
                    </v-col>
                    <v-col md="4" class="mt-0 pt-0">
                      <v-checkbox
                          class="qp-custom-checkbox no-height m-b-0"
                          v-model="venueForm.enable_surface_type"
                          label="Enable Surface Type"
                          :ripple="false"
                          hide-details="auto"
                      ></v-checkbox>
                    </v-col>
                    <v-col md="4"></v-col>
                  </v-row>

<!--                  <v-row no-gutters justify="center">-->
<!--                    <v-col sm="11">-->
<!--                      <image-upload-->
<!--                          @upload="-->
<!--                          (data) => {-->
<!--                            venueForm.image = data;-->
<!--                          }-->
<!--                        "-->
<!--                          @remove="-->
<!--                          () => {-->
<!--                            venueForm.profile_image = null;-->
<!--                          }-->
<!--                        "-->
<!--                          :image_path="venueForm.image_path"-->
<!--                          :height="200"-->
<!--                          ref="image_upload"-->
<!--                      ></image-upload>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
<!--                  <v-row class="ma-1">-->
<!--                    <v-col md="12">-->
<!--                      <v-radio-group-->
<!--                          class="d-flex"-->
<!--                          label="Third Party"-->
<!--                          v-model="venueForm.third_party"-->
<!--                          row-->
<!--                          mandatory-->
<!--                          :rules="[(v) => !!v || 'Select third party']"-->
<!--                      >-->
<!--                        <v-radio-->
<!--                            label="Priohub"-->
<!--                            color="primary"-->
<!--                            value="priohub"-->
<!--                            selected-->
<!--                            @click="changeThirdParty()"-->
<!--                        ></v-radio>-->
<!--                        <v-radio-->
<!--                            label="Qportal"-->
<!--                            color="primary"-->
<!--                            value="qportal"-->
<!--                            @click="changeThirdParty()"-->
<!--                        ></v-radio>-->
<!--                      </v-radio-group>-->
<!--                    </v-col>-->
<!--                    <v-col cols="12">-->
<!--                      <v-select-->
<!--                          label="Select Venue"-->
<!--                          v-model="changeVenue"-->
<!--                          item-value="id"-->
<!--                          item-text="name"-->
<!--                          :items="thirdPartyVenues"-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                          return-object-->
<!--                      ></v-select>-->
<!--                    </v-col>-->
<!--                    <v-col cols="12">-->
<!--                      <v-text-field-->
<!--                          v-model="venueForm.name"-->
<!--                          :rules="nameRules"-->
<!--                          label="Venue Name"-->
<!--                          required-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col cols="12">-->
<!--                      <v-text-field-->
<!--                          v-model="venueForm.phone"-->
<!--                          label="Phone"-->
<!--                          required-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col cols="12">-->
<!--                      <v-text-field-->
<!--                          v-model="venueForm.email"-->
<!--                          label="Email"-->
<!--                          required-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col cols="12">-->
<!--                      <div class="titles mt-8">Address</div>-->
<!--                      <v-card rounded flat style="border: 2px solid #a5a5a5ff">-->
<!--                        <v-btn-->
<!--                            fab-->
<!--                            absolute-->
<!--                            top-->
<!--                            right-->
<!--                            x-small-->
<!--                            elevation="1"-->
<!--                            @click="mapFullScreenDialoge = true"-->
<!--                        >-->
<!--                          <v-icon>mdi-fullscreen</v-icon>-->
<!--                        </v-btn>-->
<!--                        <v-card-text>-->
<!--                          <v-row>-->
<!--                            <v-col cols="12" sm="12" md="12">-->
<!--                              <v-row no-gutters v-if="!mapFullScreenDialoge">-->
<!--                                <v-col md="12">-->
<!--                                  <v-autocomplete-->
<!--                                      label="Location"-->
<!--                                      v-model="autocompleteLocationModel"-->
<!--                                      :items="locationEntries"-->
<!--                                      :search-input.sync="locationSearchText"-->
<!--                                      item-text="value"-->
<!--                                      item-value="value"-->
<!--                                      hide-no-data-->
<!--                                      :loading="isLoading"-->
<!--                                      :rules="[-->
<!--                                      (v) => !!v || 'Location is required',-->
<!--                                    ]"-->
<!--                                      outlined-->
<!--                                      background-color="#fff"-->
<!--                                      @change="changeLocation"-->
<!--                                  ></v-autocomplete>-->
<!--                                </v-col>-->
<!--                              </v-row>-->
<!--                              <GmapMap-->
<!--                                  v-bind:center="{-->
<!--                                  lat: parseFloat(venueForm.latitude),-->
<!--                                  lng: parseFloat(venueForm.longitude),-->
<!--                                }"-->
<!--                                  :zoom="12"-->
<!--                                  map-type-id="terrain"-->
<!--                                  @click="updateCoordinates"-->
<!--                                  style="width: 100%; height: 200px"-->
<!--                              >-->
<!--                                <GmapMarker-->
<!--                                    ref="mapRef"-->
<!--                                    :position="{-->
<!--                                    lat: parseFloat(venueForm.latitude),-->
<!--                                    lng: parseFloat(venueForm.longitude),-->
<!--                                  }"-->
<!--                                    :clickable="true"-->
<!--                                    :draggable="true"-->
<!--                                    @dragend="updateCoordinates"-->
<!--                                />-->
<!--                              </GmapMap>-->
<!--                            </v-col>-->
<!--                          </v-row>-->
<!--                        </v-card-text>-->
<!--                      </v-card>-->
<!--                    </v-col>-->

<!--                    <v-col cols="12">-->
<!--                      <v-text-field-->
<!--                          v-model="venueForm.latitude"-->
<!--                          label="Latitude"-->
<!--                          required-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col cols="12">-->
<!--                      <v-text-field-->
<!--                          v-model="venueForm.longitude"-->
<!--                          label="Longitude"-->
<!--                          required-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col sm="12">-->
<!--                      <v-textarea-->
<!--                          name="description"-->
<!--                          label="About Venue"-->
<!--                          v-model="venueForm.description"-->
<!--                          value-->
<!--                          outlined-->
<!--                          background-color="#fff"-->
<!--                          rows="3"-->
<!--                      ></v-textarea>-->
<!--                    </v-col>-->

<!--                    &lt;!&ndash; <v-col md="12">-->
<!--                      <v-autocomplete-->
<!--                        :items="venueServices"-->
<!--                        v-model="venueForm.venueServiceIds"-->
<!--                        item-value="id"-->
<!--                        item-text="service_name"-->
<!--                        label="Service"-->
<!--                        outlined-->
<!--                        multiple-->
<!--                        background-color="#fff"-->
<!--                        mandatory-->
<!--                        required-->
<!--                        :rules="[(v) => !!v || 'Select Service']"-->
<!--                      >-->
<!--                        <template v-slot:prepend-item>-->
<!--                          <v-list-item ripple @click="toggleSelect()">-->
<!--                            <v-list-item-action>-->
<!--                              <v-icon-->
<!--                                :color="-->
<!--                                  venueForm.venueServiceIds != undefined &&-->
<!--                                  venueForm.venueServiceIds.length > 0-->
<!--                                    ? 'indigo darken-4'-->
<!--                                    : ''-->
<!--                                "-->
<!--                                >{{ getIcon() }}</v-icon-->
<!--                              >-->
<!--                            </v-list-item-action>-->
<!--                            <v-list-item-content>-->
<!--                              <v-list-item-title>All</v-list-item-title>-->
<!--                            </v-list-item-content>-->
<!--                          </v-list-item>-->
<!--                        </template>-->
<!--                        <template-->
<!--                          v-if="-->
<!--                            venueForm.venueServiceIds != undefined &&-->
<!--                              venueForm.venueServiceIds.length ==-->
<!--                                venueServices.length-->
<!--                          "-->
<!--                          v-slot:selection="{ index }"-->
<!--                        >-->
<!--                          <span v-if="index == 0">All Services</span>-->
<!--                        </template>-->
<!--                        <template v-else v-slot:selection="{ item, index }">-->
<!--                          <span v-if="index == 0">{{ item.service_name }}</span>-->
<!--                          <span v-if="index == 1"-->
<!--                            >, {{ item.service_name }}</span-->
<!--                          >-->
<!--                          <span v-if="index == 2">, ...</span>-->
<!--                        </template>-->
<!--                      </v-autocomplete>-->
<!--                    </v-col> &ndash;&gt;-->
<!--                    <v-col md="12">-->
<!--                      <v-text-field-->
<!--                          outlined-->
<!--                          :rules="commissionRules"-->
<!--                          type="number"-->
<!--                          label="Rate % Per Transaction"-->
<!--                          background-color="#fff"-->
<!--                          v-model="venueForm.commission_pct"-->
<!--                          value-->
<!--                          prefix="%"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col md="12">-->
<!--                      <v-text-field-->
<!--                          outlined-->
<!--                          label="Fee Per Transaction"-->
<!--                          background-color="#fff"-->
<!--                          type="number"-->
<!--                          v-model="venueForm.commission_extra"-->
<!--                          :rules="commissionRules"-->
<!--                          value-->
<!--                          prefix="AED"-->
<!--                      ></v-text-field>-->
<!--                    </v-col>-->
<!--                    <v-col md="6" class="mt-0 pt-0">-->
<!--                      <v-checkbox-->
<!--                          class="mt-0 pt-0"-->
<!--                          v-model="venueForm.enable_duration"-->
<!--                          label="Enable Duration"-->
<!--                      ></v-checkbox>-->
<!--                    </v-col>-->
<!--                    <v-col md="6" class="mt-0 pt-0">-->
<!--                      <v-checkbox-->
<!--                          class="mt-0 pt-0"-->
<!--                          v-model="venueForm.enable_attendee_limit"-->
<!--                          label="Enable Attendee Limit"-->
<!--                      ></v-checkbox>-->
<!--                    </v-col>-->
<!--                    <v-col md="6" class="mt-0 pt-0">-->
<!--                      <v-checkbox-->
<!--                          class="mt-0 pt-0"-->
<!--                          v-model="venueForm.enable_ground_type"-->
<!--                          label="Enable Ground Type"-->
<!--                      ></v-checkbox>-->
<!--                    </v-col>-->
<!--                    <v-col md="6" class="mt-0 pt-0">-->
<!--                      <v-checkbox-->
<!--                          class="mt-0 pt-0"-->
<!--                          v-model="venueForm.enable_surface_type"-->
<!--                          label="Enable Surface Type"-->
<!--                      ></v-checkbox>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="ma-2" text @click="cancelForm">
            Close
          </v-btn>
          <v-btn
              class="ma-2 white--text blue-color"
              text
              @click="addUpdateVenue"
          >{{ editFlag ? "Update" : "Add" }} Venue
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="locationDialoge" scrollable persistent width="40%">
      <v-card>
        <v-card-title class="headline">Select Location</v-card-title>
        <v-card-text class="pa-5">
          <v-row>
            Please select a location from the list. If you don't see correct
            location name in the list below try changing location on map by
            dragging the marker or clicking on the preffered location.
          </v-row>
          <v-row>
            <v-select
                :items="mapLocations"
                item-text="formatted_address"
                item-value="formatted_address"
                v-model="venueForm.address"
                outlined
            ></v-select>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue-color white--text" text @click="closeLocation"
          >Close
          </v-btn
          >
          <v-btn class="teal-color white--text" text @click="dragMapChange"
          >Done
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mapFullScreenDialoge" scrollable width="80%">
      <v-card>
        <v-card-text class="pa-4">
          <v-row no-gutters v-if="mapFullScreenDialoge">
            <v-col md="12">
              <label for="">Select Address</label>
              <v-autocomplete
                  dense
                  hide-details="auto"
                  v-model="autocompleteLocationModel"
                  :items="locationEntries"
                  :search-input.sync="locationSearchText"
                  item-text="value"
                  item-value="value"
                  hide-no-data
                  :loading="isLoading"
                  outlined
                  background-color="#fff"
                  @change="changeLocation"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <GmapMap
              v-bind:center="{
              lat: parseFloat(venueForm.latitude),
              lng: parseFloat(venueForm.longitude),
            }"
              :zoom="12"
              map-type-id="terrain"
              @click="updateCoordinates"
              style="width: 100%; height: 600px"
          >
            <GmapMarker
                ref="mapRef"
                :position="{
                lat: parseFloat(venueForm.latitude),
                lng: parseFloat(venueForm.longitude),
              }"
                :clickable="true"
                :draggable="true"
                @dragend="updateCoordinates"
            />
          </GmapMap>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-model
        v-bind="confirmModel"
        @confirm="confirmActions"
        @close="confirmModel.id = null"
    ></confirm-model>
  </v-container>
</template>
<script>
import {GetSuggestions, placeDetails} from "@/utils/placesUtils";
import ConfirmModel from "@/components/Confirmation/ConfirmModel";
import VenueCard from "@/components/Venues/VenueCard.vue";
import SvgIcon from "@/components/Image/SvgIcon.vue";
// import DotsIcon from "@/assets/images/misc/h-options.svg";
// import DeleteIcon from "@/assets/images/misc/delete.svg";
// import ActivateIcon from "@/assets/images/misc/activate.svg";
// import DeactivateIcon from "@/assets/images/misc/deactivate.svg";
// import FeatureIcon from "@/assets/images/misc/feature.svg";
// import FeaturedIcon from "@/assets/images/misc/featured.svg";
import QportalIcon from "@/assets/images/misc/qportal.svg";
import PriohubIcon from "@/assets/images/misc/Priohub.svg";
import SearchIcon from "@/assets/images/misc/search.svg";
import AddIcon from "@/assets/images/misc/plus-icon.svg";
import ImageUploader from "@/components/Image/ImageUploader.vue";
/* global google */

export default {
  data() {
    return {
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      statusId: 'all',
      search: '',
      providerQportal: "btn_bg",
      providerPriohub: null,
      addStageDialog: false,
      locationDialoge: false,
      mapFullScreenDialoge: false,
      mapLocations: [],
      locationHistory: {},
      categoryId: "",
      addVenueModel: false,
      qportalVenues: [],
      priohubVenues: [],
      uploadedImage: false,
      autocompleteLocationModel: null,
      venues: [],
      commissionRules: [
        (value) => value >= 0 || "Minimum 0",
        (value) => value <= 100 || "Maximum 100",
      ],
      names: [],
      name: null,
      phones: [],
      phone: null,
      emails: [],
      email: null,
      venueForm: {
        name: null,
        latitude: 24.46436049078158,
        longitude: 54.37532545660189,
        address: null,
        venueServiceIds: [],
        third_party: "qportal",
      },
      searchParams: {
        timestamp: null,
        name: null,
        phone: null,
        email: null,
      },
      page: 1,
      totalPages: 1,
      show2: false,
      valid: true,
      thirdPartyVenues: [],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 6) || "Min 6 characters",
      },
      nameRules: [(v) => !!v || "Name is required"],
      category: null,
      editFlag: false,
      modules: [],
      subModules: [],
      Venue: {},
      height: 500,
      selectAll: false,
      changeVenue: false,
      isLoading: false,
      locationSearchText: null,
      locationEntries: [],
    };
  },
  components: {
    ImageUploader,
    // DeactivateIcon,
    // ActivateIcon,
    // DeleteIcon,
    // DotsIcon,
    SvgIcon,
    ConfirmModel,
    // FeatureIcon,
    // FeaturedIcon,
    QportalIcon,
    PriohubIcon,
    SearchIcon,
    AddIcon,
    VenueCard
  },
  mounted() {
    this.getVenues();
    this.$store.dispatch("loadServices");

    this.$store.dispatch("loadQportalVenues");

    this.$store.dispatch("loadPriohubVenues");
  },
  computed: {
    venueServices() {
      return this.$store.getters.getServices.data;
    },
    qportalVenueList() {
      return this.$store.getters.getQportalVenues.data;
    },
    priohubVenueList() {
      return this.$store.getters.getPriohubVenues.data;
    },
  },
  watch: {
    page() {
      this.getVenues();
    },
    changeVenue(value) {
      this.venueForm.venue_id = value.id;
      this.venueForm.name = value.name;
      if (this.editFlag === false && this.venueForm.venue_id)
        this.getVenueDetails();
      return true;
    },
    locationSearchText(newVal) {
      var _vue = this;
      if (
          newVal == null ||
          newVal.length == 0 ||
          this.autocompleteLocationModel == newVal
      )
        return;
      this.isLoading = true;
      GetSuggestions(newVal)
          .then(function (res) {
            _vue.isLoading = false;
            _vue.locationEntries = res;
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("name", val);
    },

    phone(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("phone", val);
    },
    email(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("email", val);
    },
  },
  methods: {
    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
          .get("admin/venues?field=" + type + "&search=" + val)
          .then((response) => {
            this.isLoading = false;
            if (response.status == 200 && response.data.status) {
              if (type == "name") {
                this.names = response.data.data;
                this.names.unshift(val);
                this.names.unshift("All");
              } else if (type == "phone") {
                this.phones = response.data.data;
                this.phones.unshift(val);
                this.phones.unshift("All");
              } else if (type == "email") {
                this.emails = response.data.data;
                this.emails.unshift(val);
                this.emails.unshift("All");
              }
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    getFilterData() {
      this.page = 1;
      this.getVenues();
    },
    changeLocation() {
      this.venueForm.address = this.autocompleteLocationModel;
      let placeId = this.locationEntries.find(
          (val) => val.value == this.autocompleteLocationModel
      ).id;
      placeDetails(placeId)
          .then((data) => {
            var lat = data[0].geometry.location.lat();
            var lng = data[0].geometry.location.lng();
            this.venueForm.latitude = lat;
            this.venueForm.longitude = lng;
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    dragMapChange() {
      this.locationEntries = [{value: this.venueForm.address, id: "0"}];
      this.autocompleteLocationModel = this.venueForm.address;
      this.locationSearchText = this.venueForm.address;
      this.locationDialoge = false;
    },
    updateCoordinates(e) {
      let lat = 24.46436049078158;
      let lng = 54.37532545660189;
      if (
          this.venueForm.latitude == undefined ||
          this.venueForm.latitude == null ||
          this.venueForm.longitude == undefined ||
          this.venueForm.longitude == null
      ) {
        this.venueForm.latitude = 24.46436049078158;
        this.venueForm.longitude = 54.37532545660189;
        lat = this.venueForm.latitude;
        lng = this.venueForm.longitude;
      } else {
        if (Number.isNaN(e.latLng.lat()) == false) {
          lat = e.latLng.lat();
          lng = e.latLng.lng();
        }
      }

      this.locationHistory.lat = parseFloat(this.venueForm.latitude);
      this.locationHistory.lng = parseFloat(this.venueForm.longitude);

      //let geocoder = new google.maps.Geocoder();
      var locationss = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      let that = this;

      if (typeof google !== undefined) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({location: locationss}, function (results, status) {
          if (status === "OK") {
            if (results.length > 0) {
              that.mapLocations = results;
              that.venueForm.location = results[0].formatted_address;
              that.locationDialoge = true;
            }
          } else {
            alert(
                "Geocode was not successful for the following reason: " + status
            );
          }
        });
      }

      this.venueForm.latitude = lat;
      this.venueForm.longitude = lng;
    },
    closeLocation() {
      this.locationDialoge = false;
      this.venueForm.latitude = this.locationHistory.lat;
      this.venueForm.longitude = this.locationHistory.lng;
      this.venueForm.address = null;
    },
    getIcon() {
      if (
          this.venueForm.venueServiceIds &&
          this.venueForm.venueServiceIds.length == 0
      )
        return "mdi-checkbox-blank-outline";

      if (
          this.venueForm.venueServiceIds &&
          this.venueServices.length == this.venueForm.venueServiceIds.length
      )
        return "mdi-close-box";
      return "mdi-minus-box";
    },
    toggleSelect() {
      this.$nextTick(() => {
        if (
            this.venueForm.venueServiceIds &&
            this.venueServices.length == this.venueForm.venueServiceIds.length
        ) {
          this.venueForm.venueServiceIds = [];
        } else {
          this.venueForm.venueServiceIds = this.venueServices.map(
              (item) => item.id
          );
        }
        this.$forceUpdate();
      });
    },
    getVenues() {
      let url = "";
      if (
          this.searchParams.name != "All" &&
          this.searchParams.name != undefined &&
          this.searchParams.name != null
      ) {
        url += "&name=" + this.searchParams.name;
      }
      if (
          this.searchParams.phone != "All" &&
          this.searchParams.phone != undefined &&
          this.searchParams.phone != null
      ) {
        url += "&phone=" + this.searchParams.phone;
      }
      if (
          this.searchParams.email != "All" &&
          this.searchParams.email != undefined &&
          this.searchParams.email != null
      ) {
        url += "&email=" + this.searchParams.email;
      }
      if (this.venueForm.third_party == "priohub") {
        url += "&provider=2";
      } else {
        url += "&provider=1";
      }

      if (this.statusId) {
        if (this.statusId === 'all') {
          url += "&status_id[0]=1&status_id[1]=2";
        } else {
          url += "&status_id[0]=" + this.statusId;
        }
      } else {
        url += "&status_id[0]=" + this.statusId;
      }

      if (this.search && this.search != '') {
        url += "&name=" + this.search;
      }

      let apiUrl = "settings/venues?per_page=10&page=" + this.page + url;
      this.$http
          .get(apiUrl)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.venues = response.data.data;
              this.totalPages = response.data.total_pages;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    changeThirdParty() {
      if (this.editFlag === false) {
        this.venueForm.name = null;
        this.venueForm.address = null;
        this.venueForm.latitude = null;
        this.venueForm.longitude = null;
        this.venueForm.description = null;
        this.venueForm.phone = null;
        this.venueForm.email = null;
        this.changeVenue = false;
      }
      if (this.venueForm.third_party == "qportal") {
        this.thirdPartyVenues = this.qportalVenueList;
      } else if (this.venueForm.third_party == "priohub") {
        this.thirdPartyVenues = Object.keys(this.priohubVenueList).map(
            (key) => this.priohubVenueList[key]
        );
      }
      return true;
    },
    getVenueDetails() {
      if (this.venueForm.third_party == "qportal") {
        this.$http
            .get("settings/thirdparty-venues/" + this.venueForm.venue_id)
            .then((response) => {
              if (response.status == 200) {
                let data = response.data.data;
                this.venueForm.name = data.name;
                if (data.latitude != null || data.latitude != undefined)
                  this.venueForm.latitude = parseFloat(data.latitude);
                if (data.longitude != null || data.longitude != undefined)
                  this.venueForm.longitude = parseFloat(data.longitude);
                this.venueForm.phone = data.phone;
                this.venueForm.email = data.email;
                this.venueForm.address = data.address;
                if (!this.venueForm.address || this.venueForm.address == null) {
                  this.venueForm.latitude = 24.46436049078158;
                  this.venueForm.longitude = 54.37532545660189;
                  this.venueForm.address = null;
                  this.locationEntries = [];
                  this.autocompleteLocationModel = null;
                  this.locationSearchText = null;
                } else {
                  this.locationEntries = [
                    {value: this.venueForm.address, id: "0"},
                  ];
                  this.autocompleteLocationModel = this.venueForm.address;
                  this.locationSearchText = this.venueForm.address;
                }
                this.venueForm.enable_duration = data.enable_duration;
                this.venueForm.enable_ground_type = data.enable_ground_type;
                this.venueForm.enable_attendee_limit = data.enable_attendee_limit;
                this.venueForm.enable_surface_type = data.enable_surface_type;
                this.$forceUpdate();
                setTimeout(() => {
                  this.onResize();
                }, 10);
              }
            })
            .catch((error) => {
              this.errorChecker(error);
            });
      }
    },
    editVenues(id) {
      if (typeof id != "undefined") {
        this.editFlag = true;

        this.$http
            .get("settings/venues/" + id)
            .then((response) => {
              if (response.status == 200) {
                let data = response.data.data;
                this.venueForm.image_path = data.profile_image;
                this.venueForm.name = data.name;
                if (data.latitude != null || data.latitude != undefined)
                  this.venueForm.latitude = parseFloat(data.latitude);
                if (data.longitude != null || data.longitude != undefined)
                  this.venueForm.longitude = parseFloat(data.longitude);
                this.venueForm.description = data.description;
                this.venueForm.address = data.address;
                this.venueForm.phone = data.phone;
                this.venueForm.email = data.email;
                this.venueForm.id = id;
                this.venueForm.commission_pct = data.commission_pct;
                this.venueForm.commission_extra = data.commission_extra;
                this.venueForm.enable_duration = data.enable_duration;
                this.venueForm.enable_ground_type = data.enable_ground_type;
                this.venueForm.enable_attendee_limit = data.enable_attendee_limit;
                this.venueForm.enable_surface_type = data.enable_surface_type;
                this.venueForm.venueServiceIds = data.services.map(
                    (item) => item.id
                );
                if (data.provider == "QPORTAL") {
                  this.thirdPartyVenues = this.qportalVenueList;
                  this.venueForm.third_party = "qportal";
                } else if (data.provider == "PRIOHUB") {
                  this.venueForm.third_party = "priohub";
                }
                this.locationEntries = [
                  {value: this.venueForm.address, id: "0"},
                ];
                this.autocompleteLocationModel = this.venueForm.address;
                this.locationSearchText = this.venueForm.address;
                // this.changeThirdParty();
                this.changeVenue = {
                  id: data.external_id,
                  name: data.name,
                };
                this.$forceUpdate();
                this.addVenueModel = true;
                setTimeout(() => {
                  this.$refs["image_upload"].cancel();
                  this.$refs.form.resetValidation();
                });
              }
            })
            .catch((error) => {
              this.errorChecker(error);
            });
      }
    },
    addVenue() {
      this.venueForm = {};
      this.venueForm.venue_service_ids = [];
      this.venueForm.third_party = "priohub";
      this.editFlag = false;
      this.changeThirdParty();
      this.addVenueModel = true;
      this.data = [];
      setTimeout(() => {
        this.$refs["image_upload"].cancel();
        this.$refs.form.resetValidation();
      });
    },
    searchFIlter() {
      this.page = 1;
      this.getVenues();
    },
    addUpdateVenue() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      this.venueForm.address = this.autocompleteLocationModel;
      let formData = new FormData();
      formData.set("venue_name", this.venueForm.name);
      if (this.venueForm.image) {
        formData.set("image", this.venueForm.image);
      }
      if (this.venueForm.description)
        formData.set("description", this.venueForm.description);
      else formData.set("description", "");
      if (this.venueForm.address)
        formData.set("address", this.venueForm.address);
      else formData.set("address", "");
      if (this.venueForm.venue_id)
        formData.set("venue_id", parseInt(this.venueForm.venue_id));

      if (this.venueForm.phone) formData.set("phone", this.venueForm.phone);
      else formData.set("phone", "");
      if (this.venueForm.email) formData.set("email", this.venueForm.email);
      else formData.set("email", "");
      if (this.venueForm.latitude)
        formData.set("latitude", this.venueForm.latitude);
      else formData.set("latitude", "");
      if (this.venueForm.longitude)
        formData.set("longitude", this.venueForm.longitude);
      else formData.set("longitude", "");

      if (this.venueForm.id) {
        formData.set("id", this.venueForm.id);
      }
      if (this.venueForm.third_party) {
        formData.set("third_party", this.venueForm.third_party);
      }
      if (this.venueForm.venueServiceIds)
        formData.set("venue_service_ids", this.venueForm.venueServiceIds);
      if (this.venueForm.commission_pct)
        formData.set("commission_pct", this.venueForm.commission_pct);
      if (this.venueForm.commission_extra)
        formData.set("commission_extra", this.venueForm.commission_extra);
      if (this.venueForm.enable_duration)
        formData.set("enable_duration", this.venueForm.enable_duration);
      if (this.venueForm.enable_ground_type)
        formData.set("enable_ground_type", this.venueForm.enable_ground_type);
      if (this.venueForm.enable_attendee_limit)
        formData.set(
            "enable_attendee_limit",
            this.venueForm.enable_attendee_limit
        );
      if (this.venueForm.enable_surface_type)
        formData.set("enable_surface_type", this.venueForm.enable_surface_type);
      this.$http({
        url:
            "settings/venues" +
            (this.venueForm.id ? `/${this.venueForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
          .then((response) => {
            if (response.status == 200) {
              this.addVenueModel = false;
              this.showSuccess("Venue Added Successfully.");
              this.getVenues();
              this.$forceUpdate();
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    syncQportalVenues() {
      this.showLoader();
      let url = "venues/sync-venues";
      this.$http
          .get(url)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.hideLoader();
              this.getVenues();
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    changeVenueStatus(id) {
      this.$http
          .put(`settings/venues/${id}/status`)
          .then((response) => {
            if (response.status == 200) {
              this.getVenues();
              this.showSuccess(`Venue updated successfully`);
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    deleteVenue(id) {
      this.$http
          .put(`settings/venues/${id}/delete`)
          .then((response) => {
            if (response.status == 200) {
              // let status = response.data.data.status_id;
              // this.venues[index].status_id = status;
              this.getVenues();
              this.showSuccess(`Venue deleted successfully`);
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    changeProvider(sel) {
      if (sel == "qportal") {
        this.venueForm.third_party = "qportal";
        this.providerQportal = "btn_bg";
        this.providerPriohub = "";
      } else {
        this.venueForm.third_party = "priohub";
        this.providerPriohub = "btn_bg";
        this.providerQportal = "";
      }
      // this.changeThirdParty();
      this.getVenues();
      this.$forceUpdate();
    },
    cancelForm() {
      this.addVenueModel = false;
      this.venueForm = {};
      this.venueForm.third_party = "priohub";
      this.editFlag = false;
      this.$refs.form.resetValidation();
      this.$forceUpdate();
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
    changeFeaturedStatus(id) {
      let msg =
          "This will Change the Featured Status. By clicking Yes you can confirm the operation.";
      this.confirmModel = {
        id: id,
        title: `Do you want to change Featured Status?`,
        description: msg,
      };
    },
    confirmActions(data) {
      this.makeItFeatured(data.id);
      this.$forceUpdate();
      this.confirmModel.id = null;
    },
    makeItFeatured(id) {
      this.$http
          .get(`admin/venues/featured-status-change/${id}`)
          .then((response) => {
            if (response.status == 200) {
              this.showSuccess(`Venue status Successfully changed.`);
              this.getVenues();
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
  },
};
</script>
<style scoped>
.validation-message {
  color: red;
  font-size: 12px;
}

.md-card {
  margin: 0 0 25px 0;
}

.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}

.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
